import React from 'react';
import ActiveAlerts from '../../components/ActiveAlerts/ActiveAlerts';
import { useAlerts } from '../../context/AlertsContext';
import NotificationsOffRoundedIcon from '@mui/icons-material/NotificationsOffRounded';
import './Alerts.css';

/**
 * Centro de alertas.
 *
 * Antes esta pantalla mantenía DOS listas en paralelo: la de `ActiveAlerts`
 * (seis alertas escritas a mano) y la del contexto (otras cinco, también a
 * mano), y encima las dividía por "leída / no leída", un estado que sólo vivía
 * en el navegador. El resultado eran hasta seis secciones mostrando alertas
 * inventadas dos veces.
 *
 * Ahora hay una sola fuente y un solo eje: activa o resuelta, que es lo que
 * distingue el backend con el campo `resolved`. "Leída" desapareció porque no
 * significaba nada fuera de esta pantalla: lo que importa de una alerta de fuga
 * no es si la miraste, es si sigue abierta.
 */
export default function Alerts() {
  const { activeAlerts, resolvedAlerts, loading, error } = useAlerts();

  const vacio = !loading && !error && activeAlerts.length === 0 && resolvedAlerts.length === 0;

  return (
    <div className="alerts-container">
      <div className="alerts-header">
        <div>
          <h2 className="section-title">Centro de alertas</h2>
          <p className="subtle" style={{ marginTop: 4, fontSize: '0.82rem' }}>
            Revisa, resuelve y archiva eventos detectados en tu instalación.
          </p>
        </div>
      </div>

      {loading && <p className="subtle">Cargando alertas…</p>}

      {vacio && (
        <div className="alerts-empty">
          <NotificationsOffRoundedIcon />
          <h3>Sin alertas</h3>
          <p>
            No hay incidencias registradas en tus dispositivos. Aparecerán aquí en cuanto se
            detecte alguna.
          </p>
        </div>
      )}

      <ActiveAlerts />
    </div>
  );
}
